var map = {
	"./popup1-min.png": "47qH",
	"./popup2-min.png": "US1d",
	"./popup3-min.png": "wBOS",
	"./popup4-min.png": "suQj",
	"./popup5-min.png": "02mx",
	"./popup6-min.png": "zCh3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QbzK";